import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { PrVnta, ProductVntaService, PrVntaData } from '../../services/product-vnta.service';
import { ActivityService, PdfActivityDisplayLabels } from '../../services/activity.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-display-pr-vnta',
  templateUrl: './display-pr-vnta.component.html',
  styleUrls: ['./display-pr-vnta.component.css']
})
export class DisplayPrVntaComponent implements OnInit {

  prVnta: any;
  sid: string;
  prVntaForm: FormGroup;

  characs = [];
  sections: any[];
  generalActivities: any[];

  currentSectionTab: number;
  currentSectionShowing: boolean;

  subs: Subscription[] = [];

  Object = Object;
  PdfActivityDisplayLabels = PdfActivityDisplayLabels;
  constructor(
    private activatedRoute: ActivatedRoute,
    private prVntaService: ProductVntaService,
    private prVntaData: PrVntaData,
    private activityService: ActivityService,
    private fb: FormBuilder
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');

    this.subs.push(
      this.prVntaService.getPrVnta(this.sid).subscribe(([{data: prType, productSatKey, unitSatKey, ...data}]) => {
        this.prVnta = {
          prTypeId: prType.name,
          productSatKey: `${productSatKey} - ${this.prVntaData.productSatKeyObjects[productSatKey].description}`,
          unitSatKey: `${unitSatKey} - ${this.prVntaData.unitSatKeyObjects[unitSatKey].description}`,
          ...data
        };
        this.prVntaForm.patchValue(this.prVnta);
        
        this.sections = data.sections;
        this.generalActivities = data.generalActivities;
        data.characs.map(charac => {
          const unitRef = charac.unitId.path;
          const unit = this.prVntaService.getUnitDoc(unitRef);
          this.subs.push(
            unit.subscribe(dataUnit => {
              charac.nameUnit = dataUnit.name;
            })
          )
        });
        this.characs = data.characs;
      })
    );
  }

  ngOnInit() {
    this.createForm();
  }
  ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  createForm() {
    this.prVntaForm = this.fb.group({
      name: '',
      description: '',
      code: '',
      prTypeId: '',
      productSatKey: '',
      unitSatKey: ''
    });
  }

  changeSectionTab(index) {
    if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
    else{
      this.currentSectionTab = index;
      this.currentSectionShowing = true;
    }
  }

}
